import styled, {css} from "styled-components";
import {HomePageHeaderArenasContainerDefaultBox} from "./home-page-header-arenas-container.default.box";
import {HeaderArenasStyle} from "../../../themes/architecture/sections/theme-layout.interface";

export const HomePageHeaderArenasContainerMrGreenBox = styled(HomePageHeaderArenasContainerDefaultBox)`
  margin-bottom: 1.4rem;
  ${({headerArenasStyle, theme}) => headerArenasStyle === HeaderArenasStyle.Menu ? css`
    background-color: ${theme.colors.backgroundContrast};
  ` : ""}

  ${({headerArenasStyle}) => headerArenasStyle === HeaderArenasStyle.Menu ? css`
    padding: 1.5rem 0 1.4rem;
  ` : ""}
  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    ${({headerArenasStyle}) => headerArenasStyle === HeaderArenasStyle.Menu ? css`
      padding: 2.2rem 0;
    ` : ""}
  }
`;
